export default __webpack_public_path__ + "static/media/rotation.d7cd3ca1.png";